export const emojis = [
    { char: "👍", alt: "thumbs up" },
    { char: "👎", alt: "thumbs down" },
    { char: "❤️", alt: "red heart" },
    { char: "\ud83c\udf89", alt: "party popper" },
    { char: "\ud83d\udc4f", alt: "clapping hands" },
    { char: "🙌", alt: "raising hands" },
    { char: "🔥", alt: "fire" },
    { char: "\ud83d\ude00", alt: "grinning face" },
    { char: "😂", alt: "face with tears of joy" },
    { char: "😍", alt: "heart eyes" },
    { char: "\ud83e\udd14", alt: "thinking face" },
    { char: "😮", alt: "astonished face" },
    { char: "👀", alt: "eyes" },
    { char: "💯", alt: "hundred points" },
    { char: "✨", alt: "sparkles" },
];


export const chatEmojis = [
    { shortcode: ":bowtie:", unicode: "😊" },
    { shortcode: ":smile:", unicode: "😄" },
    { shortcode: ":laughing:", unicode: "😆" },
    { shortcode: ":blush:", unicode: "😊" },
    { shortcode: ":smiley:", unicode: "😃" },
    { shortcode: ":relaxed:", unicode: "☺️" },
    { shortcode: ":smirk:", unicode: "😏" },
    { shortcode: ":heart_eyes:", unicode: "😍" },
    { shortcode: ":kissing_heart:", unicode: "😘" },
    { shortcode: ":kissing_closed_eyes:", unicode: "😚" },
    { shortcode: ":flushed:", unicode: "😳" },
    { shortcode: ":relieved:", unicode: "😌" },
    { shortcode: ":satisfied:", unicode: "😆" },
    { shortcode: ":grin:", unicode: "😁" },
    { shortcode: ":wink:", unicode: "😉" },
    { shortcode: ":stuck_out_tongue_winking_eye:", unicode: "😜" },
    { shortcode: ":stuck_out_tongue_closed_eyes:", unicode: "😝" },
    { shortcode: ":grinning:", unicode: "😀" },
    { shortcode: ":kissing:", unicode: "😗" },
    { shortcode: ":kissing_smiling_eyes:", unicode: "😙" },
    { shortcode: ":stuck_out_tongue:", unicode: "😛" },
    { shortcode: ":sleeping:", unicode: "😴" },
    { shortcode: ":worried:", unicode: "😟" },
    { shortcode: ":frowning:", unicode: "🙁" },
    { shortcode: ":anguished:", unicode: "😧" },
    { shortcode: ":open_mouth:", unicode: "😮" },
    { shortcode: ":grimacing:", unicode: "😬" },
    { shortcode: ":confused:", unicode: "😕" },
    { shortcode: ":hushed:", unicode: "😯" },
    { shortcode: ":expressionless:", unicode: "😑" },
    { shortcode: ":unamused:", unicode: "😒" },
    { shortcode: ":sweat_smile:", unicode: "😅" },
    { shortcode: ":sweat:", unicode: "😓" },
    { shortcode: ":disappointed_relieved:", unicode: "😥" },
    { shortcode: ":weary:", unicode: "😩" },
    { shortcode: ":pensive:", unicode: "😔" },
    { shortcode: ":disappointed:", unicode: "😞" },
    { shortcode: ":confounded:", unicode: "😖" },
    { shortcode: ":fearful:", unicode: "😨" },
    { shortcode: ":cold_sweat:", unicode: "😰" },
    { shortcode: ":persevere:", unicode: "😣" },
    { shortcode: ":cry:", unicode: "😢" },
    { shortcode: ":sob:", unicode: "😭" },
    { shortcode: ":joy:", unicode: "😂" },
    { shortcode: ":astonished:", unicode: "😲" },
    { shortcode: ":scream:", unicode: "😱" },
    { shortcode: ":neckbeard:", unicode: "🧔" },
    { shortcode: ":tired_face:", unicode: "😫" },
    { shortcode: ":angry:", unicode: "😠" },
    { shortcode: ":rage:", unicode: "😡" },
    { shortcode: ":triumph:", unicode: "😤" },
    { shortcode: ":sleepy:", unicode: "😪" },
    { shortcode: ":yum:", unicode: "😋" },
    { shortcode: ":mask:", unicode: "😷" },
    { shortcode: ":sunglasses:", unicode: "😎" },
    { shortcode: ":dizzy_face:", unicode: "😵" },
    { shortcode: ":imp:", unicode: "👿" },
    { shortcode: ":smiling_imp:", unicode: "😈" },
    { shortcode: ":neutral_face:", unicode: "😐" },
    { shortcode: ":no_mouth:", unicode: "😶" },
    { shortcode: ":innocent:", unicode: "😇" },
    { shortcode: ":alien:", unicode: "👽" },
    { shortcode: ":yellow_heart:", unicode: "💛" },
    { shortcode: ":blue_heart:", unicode: "💙" },
    { shortcode: ":purple_heart:", unicode: "💜" },
    { shortcode: ":heart:", unicode: "❤️" },
    { shortcode: ":green_heart:", unicode: "💚" },
    { shortcode: ":broken_heart:", unicode: "💔" },
    { shortcode: ":heartbeat:", unicode: "💓" },
    { shortcode: ":heartpulse:", unicode: "💗" },
    { shortcode: ":two_hearts:", unicode: "💕" },
    { shortcode: ":revolving_hearts:", unicode: "💞" },
    { shortcode: ":cupid:", unicode: "💘" },
    { shortcode: ":sparkling_heart:", unicode: "💖" },
    { shortcode: ":sparkles:", unicode: "✨" },
    { shortcode: ":star:", unicode: "⭐" },
    { shortcode: ":star2:", unicode: "🌟" },
    { shortcode: ":dizzy:", unicode: "💫" },
    { shortcode: ":boom:", unicode: "💥" },
    { shortcode: ":collision:", unicode: "💥" },
    { shortcode: ":anger:", unicode: "💢" },
    { shortcode: ":exclamation:", unicode: "❗" },
    { shortcode: ":question:", unicode: "❓" },
    { shortcode: ":grey_exclamation:", unicode: "❕" },
    { shortcode: ":grey_question:", unicode: "❔" },
    { shortcode: ":zzz:", unicode: "💤" },
    { shortcode: ":dash:", unicode: "💨" },
    { shortcode: ":sweat_drops:", unicode: "💦" },
    { shortcode: ":notes:", unicode: "🎶" },
    { shortcode: ":musical_note:", unicode: "🎵" },
    { shortcode: ":fire:", unicode: "🔥" },
    { shortcode: ":hankey:", unicode: "💩" },
    { shortcode: ":poop:", unicode: "💩" },
    { shortcode: ":shit:", unicode: "💩" },
    { shortcode: ":thumbsup:", unicode: "👍" },
    { shortcode: ":thumbsdown:", unicode: "👎" },
    { shortcode: ":ok_hand:", unicode: "👌" },
    { shortcode: ":punch:", unicode: "👊" },
    { shortcode: ":facepunch:", unicode: "👊" },
    { shortcode: ":fist:", unicode: "✊" },
    { shortcode: ":v:", unicode: "✌️" },
    { shortcode: ":wave:", unicode: "👋" },
    { shortcode: ":hand:", unicode: "✋" },
    { shortcode: ":raised_hand:", unicode: "✋" },
    { shortcode: ":open_hands:", unicode: "👐" },
    { shortcode: ":point_up:", unicode: "☝️" },
    { shortcode: ":point_down:", unicode: "👇" },
    { shortcode: ":point_left:", unicode: "👈" },
    { shortcode: ":point_right:", unicode: "👉" },
    { shortcode: ":raised_hands:", unicode: "🙌" },
    { shortcode: ":pray:", unicode: "🙏" },
    { shortcode: ":point_up_2:", unicode: "👆" },
    { shortcode: ":clap:", unicode: "👏" },
    { shortcode: ":muscle:", unicode: "💪" },
    { shortcode: ":metal:", unicode: "🤘" },
    { shortcode: ":fu:", unicode: "🖕" },
    { shortcode: ":walking:", unicode: "🚶" },
    { shortcode: ":runner:", unicode: "🏃" },
    { shortcode: ":running:", unicode: "🏃" },
    { shortcode: ":couple:", unicode: "👫" },
    { shortcode: ":family:", unicode: "👪" },
    { shortcode: ":two_men_holding_hands:", unicode: "👬" },
    { shortcode: ":two_women_holding_hands:", unicode: "👭" },
    { shortcode: ":dancer:", unicode: "💃" },
    { shortcode: ":dancers:", unicode: "👯" },
    { shortcode: ":ok_woman:", unicode: "🙆" },
    { shortcode: ":no_good:", unicode: "🙅" },
    { shortcode: ":information_desk_person:", unicode: "💁" },
    { shortcode: ":raising_hand:", unicode: "🙋" },
    { shortcode: ":bride_with_veil:", unicode: "👰" },
    { shortcode: ":person_with_pouting_face:", unicode: "🙎" },
    { shortcode: ":person_frowning:", unicode: "🙍" },
    { shortcode: ":bow:", unicode: "🙇" },
    { shortcode: ":couplekiss:", unicode: "💏" },
    { shortcode: ":couple_with_heart:", unicode: "💑" },
    { shortcode: ":massage:", unicode: "💆" },
    { shortcode: ":haircut:", unicode: "💇" },
    { shortcode: ":nail_care:", unicode: "💅" },
    { shortcode: ":boy:", unicode: "👦" },
    { shortcode: ":girl:", unicode: "👧" },
    { shortcode: ":woman:", unicode: "👩" },
    { shortcode: ":man:", unicode: "👨" },
    { shortcode: ":baby:", unicode: "👶" },
    { shortcode: ":older_woman:", unicode: "👵" }
]


export const translationLanguages = [
    { language: "Arabic (Egypt)", code: "ar-EG" },
    { language: "Arabic (Saudi Arabia)", code: "ar-SA" },
    { language: "Bulgarian", code: "bg" },
    { language: "Catalan", code: "ca" },
    { language: "Chinese (Mandarin, Simplified)", code: "zh" },
    { language: "Chinese (Mandarin, Traditional)", code: "zh-TW" },
    { language: "Chinese (Cantonese, Traditional)", code: "zh-HK" },
    { language: "Czech", code: "cs" },
    { language: "Danish", code: "da" },
    { language: "Dutch", code: "nl" },
    { language: "English", code: "en" },
    { language: "Estonian", code: "et" },
    { language: "Finnish", code: "fi" },
    { language: "Flemish", code: "nl-BE" },
    { language: "French", code: "fr" },
    { language: "German", code: "de" },
    { language: "German (Switzerland)", code: "de-CH" },
    { language: "Greek", code: "el" },
    { language: "Hindi", code: "hi" },
    { language: "Hungarian", code: "hu" },
    { language: "Indonesian", code: "id" },
    { language: "Italian", code: "it" },
    { language: "Japanese", code: "ja" },
    { language: "Korean", code: "ko" },
    { language: "Latvian", code: "lv" },
    { language: "Lithuanian", code: "lt" },
    { language: "Malay", code: "ms" },
    { language: "Norwegian", code: "no" },
    { language: "Polish", code: "pl" },
    { language: "Portuguese", code: "pt" },
    { language: "Romanian", code: "ro" },
    { language: "Russian", code: "ru" },
    { language: "Slovak", code: "sk" },
    { language: "Spanish", code: "es" },
    { language: "Swedish", code: "sv" },
    { language: "Tagalog", code: "tl" },
    { language: "Thai", code: "th" },
    { language: "Turkish", code: "tr" },
    { language: "Ukrainian", code: "uk" },
    { language: "Vietnamese", code: "vi" }
];